<template>
  <a href="#contact-footer" class="demo-button" v-on:click="getDemoEvent">Get a demo</a>
</template>



<script>

import eventDispatcher from '../../../../events/dispatch'

export default {
  props: [ 'buttonMessage' ],
  mounted() {},
  methods: {
    getDemoEvent() {
      let msg = this.buttonMessage
      eventDispatcher('requestDemoClicked', {
        sourceOfDemo: msg
      })
    },
  },
  computed: {},
  watch: {}
}
</script>

<style scoped>

.demo-button {
  background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
  color: #fff;
  font-size: 22px;
  text-decoration: none;
  cursor: pointer;
  min-width: 224px;
  max-width: 300px;
  text-align: center;
  padding: 8px;
  border-radius: 3px;
  margin: 60px 0px;
  display: block;
  cursor: pointer;
  box-shadow: 0 2px 6px #00000024;
  font-weight: lighter;
  text-decoration: none;
  letter-spacing: 1px;
  border: none;
}

@media only screen and (max-width: 1000px) {
  .demo-button {
    margin: 60px auto !important;
  }
}

@media only screen and (max-width: 550px) {
  .demo-button {
    display: none !important;
  }
}

</style>



// WEBPACK FOOTER //
// GetDemoButton.vue?22f809de